// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see CustomerSupportAccessStartEvent
 */
export var CustomerSupportAccessStart = function (_a) {
    var destination = _a.destination, flowToken = _a.flowToken, trigger = _a.trigger, triggerEntityId = _a.triggerEntityId, triggerNodeToken = _a.triggerNodeToken, exitScreen = _a.exitScreen, customerIsDenylisted = _a.customerIsDenylisted;
    return ({
        name: "CustomerSupport Access Start",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Access",
            destination: destination !== undefined && destination !== null ? destination.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger_entity_id: triggerEntityId !== undefined && triggerEntityId !== null ? triggerEntityId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger_node_token: triggerNodeToken !== undefined && triggerNodeToken !== null ? triggerNodeToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            exit_screen: exitScreen !== undefined && exitScreen !== null ? exitScreen.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            customer_is_denylisted: customerIsDenylisted !== undefined && customerIsDenylisted !== null ? customerIsDenylisted.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportAccessCompleteEvent
 */
export var CustomerSupportAccessComplete = function (_a) {
    var flowToken = _a.flowToken, hasUnreadMessages = _a.hasUnreadMessages;
    return ({
        name: "CustomerSupport Access Complete",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Access",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            has_unread_messages: hasUnreadMessages !== undefined && hasUnreadMessages !== null ? hasUnreadMessages.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportAccessViewIncidentAlertsEvent
 */
export var CustomerSupportAccessViewIncidentAlerts = function (_a) {
    var flowToken = _a.flowToken, totalCount = _a.totalCount, trigger = _a.trigger;
    return ({
        name: "CustomerSupport Access ViewIncidentAlerts",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Access",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            total_count: totalCount !== undefined && totalCount !== null ? totalCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportAccessOpenIncidentAlertEvent
 */
export var CustomerSupportAccessOpenIncidentAlert = function (_a) {
    var action = _a.action, flowToken = _a.flowToken, incidentId = _a.incidentId, numberOfIncidents = _a.numberOfIncidents, position = _a.position, status = _a.status, trigger = _a.trigger;
    return ({
        name: "CustomerSupport Access OpenIncidentAlert",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Access",
            action: action !== undefined && action !== null ? action.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            incident_id: incidentId !== undefined && incidentId !== null ? incidentId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            number_of_incidents: numberOfIncidents !== undefined && numberOfIncidents !== null ? numberOfIncidents.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            position: position !== undefined && position !== null ? position.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            status: status !== undefined && status !== null ? status.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportAccessChangeIncidentAlertEvent
 */
export var CustomerSupportAccessChangeIncidentAlert = function (_a) {
    var action = _a.action, flowToken = _a.flowToken, incidentId = _a.incidentId, status = _a.status;
    return ({
        name: "CustomerSupport Access ChangeIncidentAlert",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Access",
            action: action !== undefined && action !== null ? action.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            incident_id: incidentId !== undefined && incidentId !== null ? incidentId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            status: status !== undefined && status !== null ? status.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportAccessViewContactOptionsEvent
 */
export var CustomerSupportAccessViewContactOptions = function (_a) {
    var flowToken = _a.flowToken, nodeToken = _a.nodeToken, viewToken = _a.viewToken, trigger = _a.trigger, chatOption = _a.chatOption, phoneOption = _a.phoneOption, emailOption = _a.emailOption;
    return ({
        name: "CustomerSupport Access ViewContactOptions",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Access",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            node_token: nodeToken !== undefined && nodeToken !== null ? nodeToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            view_token: viewToken !== undefined && viewToken !== null ? viewToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            chat_option: chatOption !== undefined && chatOption !== null ? chatOption.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            phone_option: phoneOption !== undefined && phoneOption !== null ? phoneOption.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            email_option: emailOption !== undefined && emailOption !== null ? emailOption.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportAccessViewTransactionsEvent
 */
export var CustomerSupportAccessViewTransactions = function (_a) {
    var flowToken = _a.flowToken, entityIds = _a.entityIds, hasMore = _a.hasMore, status = _a.status;
    return ({
        name: "CustomerSupport Access ViewTransactions",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Access",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entity_ids: entityIds !== undefined && entityIds !== null ? entityIds.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            has_more: hasMore !== undefined && hasMore !== null ? hasMore.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            status: status !== undefined && status !== null ? status.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportAccessSelectTransactionEvent
 */
export var CustomerSupportAccessSelectTransaction = function (_a) {
    var flowToken = _a.flowToken, entityId = _a.entityId;
    return ({
        name: "CustomerSupport Access SelectTransaction",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Access",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entity_id: entityId !== undefined && entityId !== null ? entityId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportAccessViewDisputesEvent
 */
export var CustomerSupportAccessViewDisputes = function (_a) {
    var flowToken = _a.flowToken, activeDisputes = _a.activeDisputes;
    return ({
        name: "CustomerSupport Access ViewDisputes",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Access",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            active_disputes: activeDisputes !== undefined && activeDisputes !== null ? activeDisputes.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportAccessOpenDisputesEvent
 */
export var CustomerSupportAccessOpenDisputes = function (_a) {
    var flowToken = _a.flowToken, activeDisputes = _a.activeDisputes;
    return ({
        name: "CustomerSupport Access OpenDisputes",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Access",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            active_disputes: activeDisputes !== undefined && activeDisputes !== null ? activeDisputes.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportAccessViewNodesEvent
 */
export var CustomerSupportAccessViewNodes = function (_a) {
    var displayTypes = _a.displayTypes, flowToken = _a.flowToken, nodeTokens = _a.nodeTokens, parentToken = _a.parentToken, searchStatus = _a.searchStatus, searchText = _a.searchText, totalCount = _a.totalCount, trigger = _a.trigger, viewToken = _a.viewToken, channelAvailability = _a.channelAvailability, entitiyId = _a.entitiyId, loadTransactionStatus = _a.loadTransactionStatus, canNavigateToReceipt = _a.canNavigateToReceipt;
    return ({
        name: "CustomerSupport Access ViewNodes",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Access",
            display_types: displayTypes !== undefined && displayTypes !== null ? displayTypes.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            node_tokens: nodeTokens !== undefined && nodeTokens !== null ? nodeTokens.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            parent_token: parentToken !== undefined && parentToken !== null ? parentToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            search_status: searchStatus !== undefined && searchStatus !== null ? searchStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            search_text: searchText !== undefined && searchText !== null ? searchText.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            total_count: totalCount !== undefined && totalCount !== null ? totalCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            view_token: viewToken !== undefined && viewToken !== null ? viewToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            channel_availability: channelAvailability !== undefined && channelAvailability !== null ? channelAvailability.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entitiy_id: entitiyId !== undefined && entitiyId !== null ? entitiyId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            load_transaction_status: loadTransactionStatus !== undefined && loadTransactionStatus !== null ? loadTransactionStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            can_navigate_to_receipt: canNavigateToReceipt !== undefined && canNavigateToReceipt !== null ? canNavigateToReceipt.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportAccessOpenTransactionDetailEvent
 */
export var CustomerSupportAccessOpenTransactionDetail = function (_a) {
    var flowToken = _a.flowToken, nodeToken = _a.nodeToken, entityId = _a.entityId, viewToken = _a.viewToken;
    return ({
        name: "CustomerSupport Access OpenTransactionDetail",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Access",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            node_token: nodeToken !== undefined && nodeToken !== null ? nodeToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entity_id: entityId !== undefined && entityId !== null ? entityId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            view_token: viewToken !== undefined && viewToken !== null ? viewToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportAccessOpenNodeEvent
 */
export var CustomerSupportAccessOpenNode = function (_a) {
    var actionClientScenario = _a.actionClientScenario, actionUrl = _a.actionUrl, flowToken = _a.flowToken, nodeToken = _a.nodeToken, selectedType = _a.selectedType, selectedTypeCount = _a.selectedTypeCount, selectedTypeIndex = _a.selectedTypeIndex, totalCount = _a.totalCount, trigger = _a.trigger, triggerEntityId = _a.triggerEntityId, triggerSearchText = _a.triggerSearchText, viewToken = _a.viewToken;
    return ({
        name: "CustomerSupport Access OpenNode",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Access",
            action_client_scenario: actionClientScenario !== undefined && actionClientScenario !== null ? actionClientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            action_url: actionUrl !== undefined && actionUrl !== null ? actionUrl.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            node_token: nodeToken !== undefined && nodeToken !== null ? nodeToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            selected_type: selectedType !== undefined && selectedType !== null ? selectedType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            selected_type_count: selectedTypeCount !== undefined && selectedTypeCount !== null ? selectedTypeCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            selected_type_index: selectedTypeIndex !== undefined && selectedTypeIndex !== null ? selectedTypeIndex.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            total_count: totalCount !== undefined && totalCount !== null ? totalCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger_entity_id: triggerEntityId !== undefined && triggerEntityId !== null ? triggerEntityId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger_search_text: triggerSearchText !== undefined && triggerSearchText !== null ? triggerSearchText.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            view_token: viewToken !== undefined && viewToken !== null ? viewToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportAccessOpenLinkEvent
 */
export var CustomerSupportAccessOpenLink = function (_a) {
    var flowToken = _a.flowToken, nodeToken = _a.nodeToken, viewToken = _a.viewToken, url = _a.url;
    return ({
        name: "CustomerSupport Access OpenLink",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Access",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            node_token: nodeToken !== undefined && nodeToken !== null ? nodeToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            view_token: viewToken !== undefined && viewToken !== null ? viewToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            url: url !== undefined && url !== null ? url.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportAccessSendPhoneVerificationAttemptNotificationEvent
 */
export var CustomerSupportAccessSendPhoneVerificationAttemptNotification = function (_a) {
    var verificationId = _a.verificationId, contactId = _a.contactId;
    return ({
        name: "CustomerSupport Access SendPhoneVerificationAttemptNotification",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Access",
            verification_id: verificationId !== undefined && verificationId !== null ? verificationId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            contact_id: contactId !== undefined && contactId !== null ? contactId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportAccessViewPhoneVerificationAttemptEvent
 */
export var CustomerSupportAccessViewPhoneVerificationAttempt = function (_a) {
    var flowToken = _a.flowToken, verificationId = _a.verificationId, status = _a.status, hasError = _a.hasError, trigger = _a.trigger;
    return ({
        name: "CustomerSupport Access ViewPhoneVerificationAttempt",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Access",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            verification_id: verificationId !== undefined && verificationId !== null ? verificationId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            status: status !== undefined && status !== null ? status.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            hasError: hasError !== undefined && hasError !== null ? hasError.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportAccessActionPhoneVerificationAttemptEvent
 */
export var CustomerSupportAccessActionPhoneVerificationAttempt = function (_a) {
    var action = _a.action, flowToken = _a.flowToken, verificationId = _a.verificationId, status = _a.status, hasError = _a.hasError;
    return ({
        name: "CustomerSupport Access ActionPhoneVerificationAttempt",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Access",
            action: action !== undefined && action !== null ? action.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            verification_id: verificationId !== undefined && verificationId !== null ? verificationId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            status: status !== undefined && status !== null ? status.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            hasError: hasError !== undefined && hasError !== null ? hasError.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportContactStartEvent
 */
export var CustomerSupportContactStart = function (_a) {
    var channel = _a.channel, flowToken = _a.flowToken, trigger = _a.trigger, triggerEntityId = _a.triggerEntityId, triggerNodeToken = _a.triggerNodeToken, viewToken = _a.viewToken, channelAvailability = _a.channelAvailability, channelStatus = _a.channelStatus, hasUnreadMessages = _a.hasUnreadMessages;
    return ({
        name: "CustomerSupport Contact Start",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Contact",
            channel: channel !== undefined && channel !== null ? channel.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger_entity_id: triggerEntityId !== undefined && triggerEntityId !== null ? triggerEntityId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger_node_token: triggerNodeToken !== undefined && triggerNodeToken !== null ? triggerNodeToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            view_token: viewToken !== undefined && viewToken !== null ? viewToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            channel_availability: channelAvailability !== undefined && channelAvailability !== null ? channelAvailability.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            channel_status: channelStatus !== undefined && channelStatus !== null ? channelStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            has_unread_messages: hasUnreadMessages !== undefined && hasUnreadMessages !== null ? hasUnreadMessages.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportContactViewSelectTransactionEvent
 */
export var CustomerSupportContactViewSelectTransaction = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "CustomerSupport Contact ViewSelectTransaction",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Contact",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportContactSubmitTransactionEvent
 */
export var CustomerSupportContactSubmitTransaction = function (_a) {
    var flowToken = _a.flowToken, entityId = _a.entityId;
    return ({
        name: "CustomerSupport Contact SubmitTransaction",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Contact",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entity_id: entityId !== undefined && entityId !== null ? entityId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportContactViewEnterContactEvent
 */
export var CustomerSupportContactViewEnterContact = function (_a) {
    var channel = _a.channel, flowToken = _a.flowToken;
    return ({
        name: "CustomerSupport Contact ViewEnterContact",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Contact",
            channel: channel !== undefined && channel !== null ? channel.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportContactSubmitContactEvent
 */
export var CustomerSupportContactSubmitContact = function (_a) {
    var channel = _a.channel, flowToken = _a.flowToken;
    return ({
        name: "CustomerSupport Contact SubmitContact",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Contact",
            channel: channel !== undefined && channel !== null ? channel.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportContactSubmitContactErrorEvent
 */
export var CustomerSupportContactSubmitContactError = function (_a) {
    var channel = _a.channel, flowToken = _a.flowToken, errorType = _a.errorType;
    return ({
        name: "CustomerSupport Contact SubmitContactError",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Contact",
            channel: channel !== undefined && channel !== null ? channel.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_type: errorType !== undefined && errorType !== null ? errorType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportContactViewEnterMessageEvent
 */
export var CustomerSupportContactViewEnterMessage = function (_a) {
    var channel = _a.channel, flowToken = _a.flowToken;
    return ({
        name: "CustomerSupport Contact ViewEnterMessage",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Contact",
            channel: channel !== undefined && channel !== null ? channel.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportContactSubmitMessageEvent
 */
export var CustomerSupportContactSubmitMessage = function (_a) {
    var channel = _a.channel, flowToken = _a.flowToken;
    return ({
        name: "CustomerSupport Contact SubmitMessage",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Contact",
            channel: channel !== undefined && channel !== null ? channel.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportContactCompleteEvent
 */
export var CustomerSupportContactComplete = function (_a) {
    var channel = _a.channel, flowToken = _a.flowToken, success = _a.success, hasUnreadMessages = _a.hasUnreadMessages, isTypingIndicatorDisplayed = _a.isTypingIndicatorDisplayed, botStatus = _a.botStatus;
    return ({
        name: "CustomerSupport Contact Complete",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Contact",
            channel: channel !== undefined && channel !== null ? channel.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            success: success !== undefined && success !== null ? success.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            has_unread_messages: hasUnreadMessages !== undefined && hasUnreadMessages !== null ? hasUnreadMessages.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_typing_indicator_displayed: isTypingIndicatorDisplayed !== undefined && isTypingIndicatorDisplayed !== null ? isTypingIndicatorDisplayed.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            bot_status: botStatus !== undefined && botStatus !== null ? botStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportContactCreateCaseEvent
 */
export var CustomerSupportContactCreateCase = function (_a) {
    var caseType = _a.caseType, flowToken = _a.flowToken, salesforceId = _a.salesforceId;
    return ({
        name: "CustomerSupport Contact CreateCase",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Contact",
            case_type: caseType !== undefined && caseType !== null ? caseType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            salesforce_id: salesforceId !== undefined && salesforceId !== null ? salesforceId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportReviewReceiveNotificationEvent
 */
export var CustomerSupportReviewReceiveNotification = function (_a) {
    var surveyToken = _a.surveyToken;
    return ({
        name: "CustomerSupport Review ReceiveNotification",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Review",
            survey_token: surveyToken !== undefined && surveyToken !== null ? surveyToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportReviewStartEvent
 */
export var CustomerSupportReviewStart = function (_a) {
    var loadStatus = _a.loadStatus, surveyToken = _a.surveyToken;
    return ({
        name: "CustomerSupport Review Start",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Review",
            load_status: loadStatus !== undefined && loadStatus !== null ? loadStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            survey_token: surveyToken !== undefined && surveyToken !== null ? surveyToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportReviewAdvanceEvent
 *
 * @deprecated This event added no value to monitoring
 */
export var CustomerSupportReviewAdvance = function (_a) {
    var step = _a.step, surveyToken = _a.surveyToken;
    return ({
        name: "CustomerSupport Review Advance",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Review",
            step: step !== undefined && step !== null ? step.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            survey_token: surveyToken !== undefined && surveyToken !== null ? surveyToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportReviewChangeFreeTextEvent
 *
 * @deprecated The corresponding free text input has been removed from survey
 */
export var CustomerSupportReviewChangeFreeText = function (_a) {
    var hasFreeText = _a.hasFreeText, surveyToken = _a.surveyToken;
    return ({
        name: "CustomerSupport Review ChangeFreeText",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Review",
            has_free_text: hasFreeText !== undefined && hasFreeText !== null ? hasFreeText.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            survey_token: surveyToken !== undefined && surveyToken !== null ? surveyToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportReviewChangeRatingEvent
 */
export var CustomerSupportReviewChangeRating = function (_a) {
    var rating = _a.rating, surveyToken = _a.surveyToken;
    return ({
        name: "CustomerSupport Review ChangeRating",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Review",
            rating: rating !== undefined && rating !== null ? rating.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            survey_token: surveyToken !== undefined && surveyToken !== null ? surveyToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportReviewChangeReasonEvent
 */
export var CustomerSupportReviewChangeReason = function (_a) {
    var reason = _a.reason, selected = _a.selected, surveyToken = _a.surveyToken;
    return ({
        name: "CustomerSupport Review ChangeReason",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Review",
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            selected: selected !== undefined && selected !== null ? selected.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            survey_token: surveyToken !== undefined && surveyToken !== null ? surveyToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportReviewChangeResolutionEvent
 */
export var CustomerSupportReviewChangeResolution = function (_a) {
    var resolved = _a.resolved, surveyToken = _a.surveyToken;
    return ({
        name: "CustomerSupport Review ChangeResolution",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Review",
            resolved: resolved !== undefined && resolved !== null ? resolved.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            survey_token: surveyToken !== undefined && surveyToken !== null ? surveyToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportReviewChangeSatisfactionEvent
 */
export var CustomerSupportReviewChangeSatisfaction = function (_a) {
    var satisfaction = _a.satisfaction, surveyToken = _a.surveyToken;
    return ({
        name: "CustomerSupport Review ChangeSatisfaction",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Review",
            satisfaction: satisfaction !== undefined && satisfaction !== null ? satisfaction.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            survey_token: surveyToken !== undefined && surveyToken !== null ? surveyToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportReviewCompleteEvent
 */
export var CustomerSupportReviewComplete = function (_a) {
    var submitStatus = _a.submitStatus, surveyToken = _a.surveyToken;
    return ({
        name: "CustomerSupport Review Complete",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Review",
            submit_status: submitStatus !== undefined && submitStatus !== null ? submitStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            survey_token: surveyToken !== undefined && surveyToken !== null ? surveyToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportReviewDismissEvent
 */
export var CustomerSupportReviewDismiss = function (_a) {
    var surveyToken = _a.surveyToken;
    return ({
        name: "CustomerSupport Review Dismiss",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Review",
            survey_token: surveyToken !== undefined && surveyToken !== null ? surveyToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportChatReceiveUnknownMessageEvent
 */
export var CustomerSupportChatReceiveUnknownMessage = function () { return ({
    name: "CustomerSupport Chat ReceiveUnknownMessage",
    parameters: {
        cdf_entity: "CustomerSupport",
        cdf_action: "Chat",
    }
}); };
/**
 * @see CustomerSupportChatSendMessageEvent
 */
export var CustomerSupportChatSendMessage = function (_a) {
    var flowToken = _a.flowToken, hasSuggestedReplies = _a.hasSuggestedReplies, isRetry = _a.isRetry, messageType = _a.messageType, botStatus = _a.botStatus, isTypingIndicatorDisplayed = _a.isTypingIndicatorDisplayed, selectedReplyToken = _a.selectedReplyToken;
    return ({
        name: "CustomerSupport Chat SendMessage",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Chat",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            has_suggested_replies: hasSuggestedReplies !== undefined && hasSuggestedReplies !== null ? hasSuggestedReplies.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_retry: isRetry !== undefined && isRetry !== null ? isRetry.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            message_type: messageType !== undefined && messageType !== null ? messageType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            bot_status: botStatus !== undefined && botStatus !== null ? botStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_typing_indicator_displayed: isTypingIndicatorDisplayed !== undefined && isTypingIndicatorDisplayed !== null ? isTypingIndicatorDisplayed.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            selected_reply_token: selectedReplyToken !== undefined && selectedReplyToken !== null ? selectedReplyToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportChatSendMessageErrorEvent
 */
export var CustomerSupportChatSendMessageError = function (_a) {
    var messageType = _a.messageType, errorType = _a.errorType, statusCode = _a.statusCode, flowToken = _a.flowToken;
    return ({
        name: "CustomerSupport Chat SendMessageError",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Chat",
            message_type: messageType !== undefined && messageType !== null ? messageType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_type: errorType !== undefined && errorType !== null ? errorType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            status_code: statusCode !== undefined && statusCode !== null ? statusCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportChatOpenMessageActionEvent
 */
export var CustomerSupportChatOpenMessageAction = function (_a) {
    var actionDetails = _a.actionDetails, actionType = _a.actionType, messageToken = _a.messageToken, flowToken = _a.flowToken;
    return ({
        name: "CustomerSupport Chat OpenMessageAction",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Chat",
            action_details: actionDetails !== undefined && actionDetails !== null ? actionDetails.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            action_type: actionType !== undefined && actionType !== null ? actionType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            message_token: messageToken !== undefined && messageToken !== null ? messageToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportChatOpenMessageImageEvent
 */
export var CustomerSupportChatOpenMessageImage = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "CustomerSupport Chat OpenMessageImage",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Chat",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportChatOpenLinkEvent
 */
export var CustomerSupportChatOpenLink = function (_a) {
    var flowToken = _a.flowToken, messageToken = _a.messageToken, url = _a.url;
    return ({
        name: "CustomerSupport Chat OpenLink",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Chat",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            message_token: messageToken !== undefined && messageToken !== null ? messageToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            url: url !== undefined && url !== null ? url.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportChatUploadAttachmentEvent
 */
export var CustomerSupportChatUploadAttachment = function (_a) {
    var durationMs = _a.durationMs, status = _a.status, flowToken = _a.flowToken;
    return ({
        name: "CustomerSupport Chat UploadAttachment",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Chat",
            duration_ms: durationMs !== undefined && durationMs !== null ? durationMs.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            status: status !== undefined && status !== null ? status.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportChatRetryImageLoadEvent
 */
export var CustomerSupportChatRetryImageLoad = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "CustomerSupport Chat RetryImageLoad",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Chat",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportChatShowAdvocateAvailabilityEvent
 *
 * @deprecated This feature is removed after support goes for 24hr
 */
export var CustomerSupportChatShowAdvocateAvailability = function (_a) {
    var flowToken = _a.flowToken, anchorMessageToken = _a.anchorMessageToken;
    return ({
        name: "CustomerSupport Chat ShowAdvocateAvailability",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Chat",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            anchor_message_token: anchorMessageToken !== undefined && anchorMessageToken !== null ? anchorMessageToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportChatEnterBackgroundEvent
 */
export var CustomerSupportChatEnterBackground = function (_a) {
    var flowToken = _a.flowToken, hasUnreadMessages = _a.hasUnreadMessages, isTypingIndicatorDisplayed = _a.isTypingIndicatorDisplayed, botStatus = _a.botStatus;
    return ({
        name: "CustomerSupport Chat EnterBackground",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Chat",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            has_unread_messages: hasUnreadMessages !== undefined && hasUnreadMessages !== null ? hasUnreadMessages.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_typing_indicator_displayed: isTypingIndicatorDisplayed !== undefined && isTypingIndicatorDisplayed !== null ? isTypingIndicatorDisplayed.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            bot_status: botStatus !== undefined && botStatus !== null ? botStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportChatReceivedSuggestedRepliesEvent
 */
export var CustomerSupportChatReceivedSuggestedReplies = function (_a) {
    var count = _a.count, flowToken = _a.flowToken, messageToken = _a.messageToken, suggestedReplyTokens = _a.suggestedReplyTokens;
    return ({
        name: "CustomerSupport Chat ReceivedSuggestedReplies",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Chat",
            count: count !== undefined && count !== null ? count.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            message_token: messageToken !== undefined && messageToken !== null ? messageToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            suggested_reply_tokens: suggestedReplyTokens !== undefined && suggestedReplyTokens !== null ? suggestedReplyTokens.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportSearchStartEvent
 */
export var CustomerSupportSearchStart = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "CustomerSupport Search Start",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Search",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportSearchEnterTextEvent
 */
export var CustomerSupportSearchEnterText = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "CustomerSupport Search EnterText",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Search",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportPhoneViewStatusEvent
 */
export var CustomerSupportPhoneViewStatus = function (_a) {
    var trigger = _a.trigger, status = _a.status, flowToken = _a.flowToken;
    return ({
        name: "CustomerSupport Phone ViewStatus",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Phone",
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            status: status !== undefined && status !== null ? status.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportPhoneCancelEvent
 */
export var CustomerSupportPhoneCancel = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "CustomerSupport Phone Cancel",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Phone",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportPhoneCallAgainEvent
 */
export var CustomerSupportPhoneCallAgain = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "CustomerSupport Phone CallAgain",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Phone",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportPhoneDismissStatusEvent
 */
export var CustomerSupportPhoneDismissStatus = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "CustomerSupport Phone DismissStatus",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Phone",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportFullTransactionPickerStartEvent
 */
export var CustomerSupportFullTransactionPickerStart = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "CustomerSupport FullTransactionPicker Start",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "FullTransactionPicker",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportFullTransactionPickerViewEvent
 */
export var CustomerSupportFullTransactionPickerView = function (_a) {
    var status = _a.status, entityIds = _a.entityIds, flowToken = _a.flowToken, hasMore = _a.hasMore;
    return ({
        name: "CustomerSupport FullTransactionPicker View",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "FullTransactionPicker",
            status: status !== undefined && status !== null ? status.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entity_ids: entityIds !== undefined && entityIds !== null ? entityIds.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            has_more: hasMore !== undefined && hasMore !== null ? hasMore.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportFullTransactionPickerSelectTransactionEvent
 */
export var CustomerSupportFullTransactionPickerSelectTransaction = function (_a) {
    var flowToken = _a.flowToken, entityId = _a.entityId;
    return ({
        name: "CustomerSupport FullTransactionPicker SelectTransaction",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "FullTransactionPicker",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entity_id: entityId !== undefined && entityId !== null ? entityId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportFullTransactionPickerLoadMoreEvent
 */
export var CustomerSupportFullTransactionPickerLoadMore = function (_a) {
    var status = _a.status, flowToken = _a.flowToken;
    return ({
        name: "CustomerSupport FullTransactionPicker LoadMore",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "FullTransactionPicker",
            status: status !== undefined && status !== null ? status.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportFullTransactionPickerReachEndEvent
 */
export var CustomerSupportFullTransactionPickerReachEnd = function (_a) {
    var entityIds = _a.entityIds, flowToken = _a.flowToken;
    return ({
        name: "CustomerSupport FullTransactionPicker ReachEnd",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "FullTransactionPicker",
            entity_ids: entityIds !== undefined && entityIds !== null ? entityIds.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportRecordViewRequestConsentEvent
 */
export var CustomerSupportRecordViewRequestConsent = function (_a) {
    var flowToken = _a.flowToken, trigger = _a.trigger;
    return ({
        name: "CustomerSupport Record ViewRequestConsent",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Record",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportRecordViewRequestExpiryEvent
 */
export var CustomerSupportRecordViewRequestExpiry = function (_a) {
    var flowToken = _a.flowToken, trigger = _a.trigger;
    return ({
        name: "CustomerSupport Record ViewRequestExpiry",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Record",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportRecordStartEvent
 */
export var CustomerSupportRecordStart = function (_a) {
    var flowToken = _a.flowToken, trigger = _a.trigger;
    return ({
        name: "CustomerSupport Record Start",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Record",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportRecordCancelEvent
 */
export var CustomerSupportRecordCancel = function (_a) {
    var flowToken = _a.flowToken, trigger = _a.trigger;
    return ({
        name: "CustomerSupport Record Cancel",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Record",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportRecordCompleteEvent
 */
export var CustomerSupportRecordComplete = function (_a) {
    var flowToken = _a.flowToken, trigger = _a.trigger;
    return ({
        name: "CustomerSupport Record Complete",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Record",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportRecordViewCompletionToastEvent
 */
export var CustomerSupportRecordViewCompletionToast = function (_a) {
    var flowToken = _a.flowToken, trigger = _a.trigger;
    return ({
        name: "CustomerSupport Record ViewCompletionToast",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Record",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportCaptureStartEvent
 */
export var CustomerSupportCaptureStart = function (_a) {
    var flowToken = _a.flowToken, requestId = _a.requestId, trigger = _a.trigger;
    return ({
        name: "CustomerSupport Capture Start",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Capture",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            request_id: requestId !== undefined && requestId !== null ? requestId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportCaptureAddScreenshotEvent
 */
export var CustomerSupportCaptureAddScreenshot = function (_a) {
    var flowToken = _a.flowToken, requestId = _a.requestId, trigger = _a.trigger;
    return ({
        name: "CustomerSupport Capture AddScreenshot",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Capture",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            request_id: requestId !== undefined && requestId !== null ? requestId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportCaptureViewScreenshotsEvent
 */
export var CustomerSupportCaptureViewScreenshots = function (_a) {
    var flowToken = _a.flowToken, requestId = _a.requestId, trigger = _a.trigger, screenshotCount = _a.screenshotCount;
    return ({
        name: "CustomerSupport Capture ViewScreenshots",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Capture",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            request_id: requestId !== undefined && requestId !== null ? requestId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            screenshot_count: screenshotCount !== undefined && screenshotCount !== null ? screenshotCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportCaptureViewScreenshotEvent
 */
export var CustomerSupportCaptureViewScreenshot = function (_a) {
    var flowToken = _a.flowToken, requestId = _a.requestId, trigger = _a.trigger;
    return ({
        name: "CustomerSupport Capture ViewScreenshot",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Capture",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            request_id: requestId !== undefined && requestId !== null ? requestId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportCaptureRemoveScreenshotEvent
 */
export var CustomerSupportCaptureRemoveScreenshot = function (_a) {
    var flowToken = _a.flowToken, requestId = _a.requestId, trigger = _a.trigger;
    return ({
        name: "CustomerSupport Capture RemoveScreenshot",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Capture",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            request_id: requestId !== undefined && requestId !== null ? requestId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportCaptureSubmitEvent
 */
export var CustomerSupportCaptureSubmit = function (_a) {
    var flowToken = _a.flowToken, requestId = _a.requestId, trigger = _a.trigger, screenshotCount = _a.screenshotCount;
    return ({
        name: "CustomerSupport Capture Submit",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Capture",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            request_id: requestId !== undefined && requestId !== null ? requestId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            screenshot_count: screenshotCount !== undefined && screenshotCount !== null ? screenshotCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportCaptureSubmitAcceptedEvent
 */
export var CustomerSupportCaptureSubmitAccepted = function (_a) {
    var idempotenceKey = _a.idempotenceKey, requestId = _a.requestId, screenshotCount = _a.screenshotCount;
    return ({
        name: "CustomerSupport Capture SubmitAccepted",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Capture",
            idempotence_key: idempotenceKey !== undefined && idempotenceKey !== null ? idempotenceKey.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            request_id: requestId !== undefined && requestId !== null ? requestId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            screenshot_count: screenshotCount !== undefined && screenshotCount !== null ? screenshotCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportCaptureReceiveErrorEvent
 */
export var CustomerSupportCaptureReceiveError = function (_a) {
    var errorType = _a.errorType, flowToken = _a.flowToken, requestId = _a.requestId, trigger = _a.trigger;
    return ({
        name: "CustomerSupport Capture ReceiveError",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Capture",
            error_type: errorType !== undefined && errorType !== null ? errorType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            request_id: requestId !== undefined && requestId !== null ? requestId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportCaptureCompleteEvent
 */
export var CustomerSupportCaptureComplete = function (_a) {
    var flowToken = _a.flowToken, requestId = _a.requestId, trigger = _a.trigger;
    return ({
        name: "CustomerSupport Capture Complete",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Capture",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            request_id: requestId !== undefined && requestId !== null ? requestId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see CustomerSupportCaptureCancelEvent
 */
export var CustomerSupportCaptureCancel = function (_a) {
    var flowToken = _a.flowToken, requestId = _a.requestId, trigger = _a.trigger;
    return ({
        name: "CustomerSupport Capture Cancel",
        parameters: {
            cdf_entity: "CustomerSupport",
            cdf_action: "Capture",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            request_id: requestId !== undefined && requestId !== null ? requestId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            trigger: trigger !== undefined && trigger !== null ? trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
